// Import all services
import { ArticleService } from "./admin/ArticleService";
import { AuthService } from "./admin/AuthService";
import { UserService } from "./admin/UserService";
import { ProxyPackageService } from "./admin/ProxyPackageService";
import { SettingsService } from "./admin/SettingsService";
import { PriceService } from "./admin/PriceService";
import { LanguageService } from "./admin/LanguageService";
import { PageService } from "./admin/PageService";
import { SiteService } from "./admin/SiteService";
import { PaymentService } from "./admin/PaymentService";
import { GoalService } from "./admin/GoalService";
import { CountryService } from "./admin/CountryService";
import { ReviewService } from "./admin/ReviewService";
import { CurrencyService } from "./admin/CurrencyService";
import { DiscountService } from "./admin/DiscountService";
import { RentPeriodService } from "./admin/RentPeriodService";
import { MobileTariffService } from "./admin/MobileTariffService";
import { MetadataService } from "./admin/MetadataService";
import { FaqService } from "./admin/FaqService";
import { EmailService } from "./admin/EmailService";
import { OrderService } from "./admin/OrderService";
import { AnalyticsService } from "./admin/AnalyticsService";
import { CrmService } from "./admin/CrmService";
import { SeoService } from "./admin/SeoService";
import { NotificationService } from "./admin/NotificationService";
import { FileService } from "./admin/FileService";
import { BrowserAddonService } from "./admin/BrowserAddonService";
import { MigrationService } from "./admin/MigrationService";
import {TranslatorService} from "./admin/TranslatorService";
import {TranslationKeyService} from "./admin/TranslationKeyService";
import { TranslationJSONService } from "./admin/TranslationJSONService";
import {TranslationPackagesService} from "./admin/TranslationPackagesService";
import {TranslationAIService} from "./admin/TranslationAIService";
import {AiService} from "./admin/AIService";
import { TelegramMetricsService } from "./admin/TelegramMetricsService";

// Create backward-compatible apiService object
const apiService = {
  // Auth
  login: AuthService.login,
  logout: AuthService.logout,
  createDefaultUser: AuthService.createDefaultUser,
  createAccount: AuthService.createAccount,
  saveToken: AuthService.saveToken,

  // Users
  getAdminUser: UserService.getAdminUser,
  usersGetAuthUser: UserService.usersGetAuthUser,
  usersGetAuthUserAsync: UserService.usersGetAuthUserAsync,
  getUserInfo: UserService.getUserInfo,
  usersGetAllBalance: UserService.usersGetAllBalance,
  usersGetAll: UserService.usersGetAll,
  usersGetSort: UserService.usersGetSort,
  getMockedUsersForAutoTests: UserService.getMockedUsersForAutoTests,
  createMockedUsersForAutoTests: UserService.createMockedUsersForAutoTests,
  updateMockedUsersForAutoTests: UserService.updateMockedUsersForAutoTests,
  deleteMockedUsersForAutoTests: UserService.deleteMockedUsersForAutoTests,
  userDataGetById: UserService.userDataGetById,
  userBalanseHistiryGetById: UserService.userBalanseHistiryGetById,
  userBalanseCorrect: UserService.userBalanseCorrect,
  userSetPassword: UserService.userSetPassword,
  usersGetAllNoPage: UserService.usersGetAllNoPage,
  userProfile: UserService.userProfile,
  usersGetUser: UserService.usersGetUser,
  usersSetNewPassword: UserService.usersSetNewPassword,
  usersCreate: UserService.usersCreate,
  usersDelete: UserService.usersDelete,
  usersSaveProfile: UserService.usersSaveProfile,
  getIpsByEmail: UserService.getIpsByEmail,
  getIpsById: UserService.getIpsById,

  // Articles
  getAllGroups: ArticleService.getAllGroups,
  getGroupById: ArticleService.getGroupById,
  createGroup: ArticleService.createGroup,
  updateGroup: ArticleService.updateGroup,
  deleteGroup: ArticleService.deleteGroup,
  setGroup: ArticleService.setGroup,
  saveArticleId: ArticleService.saveArticleId,
  getArticles: ArticleService.getArticles,
  getArticle: ArticleService.getArticle,
  updateArticleTranslations: ArticleService.updateArticleTranslations,
  saveArticleTranslations: ArticleService.saveArticleTranslations,
  uploadImage: ArticleService.uploadImage,
  uploadMainImage: ArticleService.uploadMainImage,
  deleteImage: ArticleService.deleteImage,
  deleteArticle: ArticleService.deleteArticle,
  saveArticle: ArticleService.saveArticle,
  setMain: ArticleService.setMain,

  // languages
  languageGet: LanguageService.languageGet,
  languageUpdate: LanguageService.languageUpdate,
  languageCreate: LanguageService.languageCreate,
  getAllLanguages: LanguageService.getAllLanguages,
  setDefaultLanguage: LanguageService.setDefaultLanguage,
  languageDelete: LanguageService.languageDelete,
  setActiveToggleLanguage: LanguageService.setActiveToggleLanguage,

  // translators
  getAllTranslatorsWithParams: TranslatorService.getAllTranslatorsWithParams,
  getAllTranslators: TranslatorService.getAllTranslators,
  addTranslator: TranslatorService.addTranslator,
  getTranslatorById: TranslatorService.getTranslatorById,
  updateTranslatorById: TranslatorService.updateTranslatorById,
  deleteTranslatorById: TranslatorService.deleteTranslatorById,
  checkTranslatorConfig: TranslatorService.checkTranslatorConfig,
  getTranslationProviders: TranslatorService.getTranslationProviders,

  // translation-keys
  getAllTranslationsKeys:TranslationKeyService.getAllTranslationsKeys,
  getPaginationTranslationsKeys:TranslationKeyService.getPaginationTranslationsKeys,
  addTranslationKeys: TranslationKeyService.addTranslationKeys,
  getTranslationKeyById: TranslationKeyService.getTranslationKeyById,
  updateTranslationKeyById: TranslationKeyService.updateTranslationKeyById,
  deleteTranslationKeyById: TranslationKeyService.deleteTranslationKeyById,
  deleteAllTranslationKeys: TranslationKeyService.deleteAllTranslationKeys,

  // translation-json
  generateTranslationsJSON:TranslationJSONService.generateTranslationsJSON,
  getTranslationJSON:TranslationJSONService.getTranslationJSON,
  updateTranslationJSON: TranslationJSONService.updateTranslationJSON,

  // translation-packages
  getAllTranslationPackagesWithParams:TranslationPackagesService.getAllTranslationPackagesWithParams,
  getPaginationTranslationPackageWithParams:TranslationPackagesService.getPaginationTranslationPackageWithParams,
  addTranslationPackage:TranslationPackagesService.addTranslationPackage,
  getTranslationPackageById:TranslationPackagesService.getTranslationPackageById,
  updateTranslationPackageById:TranslationPackagesService.updateTranslationPackageById,
  getStatisticsTranslationPackageById:TranslationPackagesService.getStatisticsTranslationPackageById,
  runTranslationProcess:TranslationPackagesService.runTranslationProcess,
  deleteTranslationPackageById:TranslationPackagesService.deleteTranslationPackageById,

  // translation-ai
  getAllAITranslations:TranslationAIService.getAllAITranslations,
  getPaginationAITranslations:TranslationAIService.getPaginationAITranslations,
  getTranslationAIById:TranslationAIService.getTranslationAIById,
  updateTranslationAiById:TranslationAIService.updateTranslationAiById,
  deleteTranslationAIById:TranslationAIService.deleteTranslationAIById,

  // ai-chat-gpt
  getAIResponse:AiService.getAIResponse,


  // Pages
  pageGetAll: PageService.pageGetAll,
  pageGet: PageService.pageGet,
  pageCreate: PageService.pageCreate,
  pageSave: PageService.pageSave,
  pageContentGet: PageService.pageContentGet,
  pageFrontContentGet: PageService.pageFrontContentGet,
  pageContentSave: PageService.pageContentSave,

  // Sites
  siteGetAll: SiteService.siteGetAll,
  siteTopGetAll: SiteService.siteTopGetAll,
  siteTopAdd: SiteService.siteTopAdd,
  siteTopSave: SiteService.siteTopSave,
  siteTopDelete: SiteService.siteTopDelete,
  siteProxyGetAll: SiteService.siteProxyGetAll,
  siteDelete: SiteService.siteDelete,
  siteProxyDelete: SiteService.siteProxyDelete,
  siteProxyDeleteImage: SiteService.siteProxyDeleteImage,
  siteProxySave: SiteService.siteProxySave,
  siteProxyGet: SiteService.siteProxyGet,

  // Payment Systems
  paymentSystemsGetAll: PaymentService.paymentSystemsGetAll,
  paymentSystemsGet: PaymentService.paymentSystemsGet,
  paymentSystemsSave: PaymentService.paymentSystemsSave,
  paymentSystemsCreate: PaymentService.paymentSystemsCreate,
  paymentSystemsDelete: PaymentService.paymentSystemsDelete,
  changePaymentSystemsOrder: PaymentService.changePaymentSystemsOrder,
  createMinimalPriceForPaymentSystem: PaymentService.createMinimalPriceForPaymentSystem,
  saveMinimalPriceForPaymentSystem: PaymentService.saveMinimalPriceForPaymentSystem,
  deleteMinimalPriceForPaymentSystem: PaymentService.deleteMinimalPriceForPaymentSystem,
  getBlockPaymentHistory: PaymentService.getBlockPaymentHistory,
  getCountBlockPaymentHistory: PaymentService.getCountBlockPaymentHistory,

  // Goals/Projects
  goalGetAll: GoalService.goalGetAll,
  goalGet: GoalService.goalGet,
  goalDelete: GoalService.goalDelete,
  goalSave: GoalService.goalSave,
  goalCreate: GoalService.goalCreate,
  goalGroupGetAll: GoalService.goalGroupGetAll,
  goalGroupGet: GoalService.goalGroupGet,
  goalGroupDelete: GoalService.goalGroupDelete,
  goalGroupSave: GoalService.goalGroupSave,
  goalGroupCreate: GoalService.goalGroupCreate,
  getViewsByProjectId: GoalService.getViewsByProjectId,
  getViewById: GoalService.getViewById,
  saveView: GoalService.saveView,
  deleteView: GoalService.deleteView,
  createView: GoalService.createView,
  getAllCustomProjects: GoalService.getAllCustomProjects,
  deleteCustomProjectById: GoalService.deleteCustomProjectById,

  // Countries
  countriesGetAll: CountryService.countriesGetAll,
  countriesGet: CountryService.countriesGet,
  countriesDelete: CountryService.countriesDelete,
  countriesSave: CountryService.countriesSave,
  countriesCreate: CountryService.countriesCreate,
  changeCountryOrder: CountryService.changeCountryOrder,

  // Reviews
  getAllReviews: ReviewService.getAllReviews,
  getAllReviewsByLocale: ReviewService.getAllReviewsByLocale,
  getReviewById: ReviewService.getReviewById,
  createReview: ReviewService.createReview,
  saveReview: ReviewService.saveReview,
  deleteReview: ReviewService.deleteReview,

  // Currencies
  getCurrencies: CurrencyService.getCurrencies,
  getCurrencyById: CurrencyService.getCurrencyById,
  createCurrency: CurrencyService.createCurrency,
  saveCurrency: CurrencyService.saveCurrency,
  deleteCurrency: CurrencyService.deleteCurrency,
  updateCurrency: CurrencyService.updateCurrency,

  // Prices
  getPrices: PriceService.getPrices,
  getPricesIPv4: PriceService.getPricesIPv4,
  getPricesIPv6: PriceService.getPricesIPv6,
  getPricesISP: PriceService.getPricesISP,
  savePriceISP: PriceService.savePriceISP,
  getPricesMobileAll: PriceService.getPricesMobileAll,
  updatePricesIpv4: PriceService.updatePricesIpv4,
  saveIPv6Prices: PriceService.saveIPv6Prices,
  changePriceForProject: PriceService.changePriceForProject,
  addPriceForProject: PriceService.addPriceForProject,
  deletePriceForProject: PriceService.deletePriceForProject,

  // Discounts
  getCountDiscount: DiscountService.getCountDiscount,
  getCountDiscountIPv6: DiscountService.getCountDiscountIPv6,
  getCountDiscountMobile: DiscountService.getCountDiscountMobile,
  getCountDiscountISP: DiscountService.getCountDiscountISP,
  getCountDiscountById: DiscountService.getCountDiscountById,
  createCountDiscount: DiscountService.createCountDiscount,
  saveCountDiscount: DiscountService.saveCountDiscount,
  deleteCountDiscount: DiscountService.deleteCountDiscount,
  getDaysDiscount: DiscountService.getDaysDiscount,
  getDaysDiscountIPv6: DiscountService.getDaysDiscountIPv6,
  getDaysDiscountISP: DiscountService.getDaysDiscountISP,
  getDaysDiscountMobile: DiscountService.getDaysDiscountMobile,
  getDaysDiscountById: DiscountService.getDaysDiscountById,
  createDaysDiscount: DiscountService.createDaysDiscount,
  saveDaysDiscount: DiscountService.saveDaysDiscount,
  deleteDaysDiscount: DiscountService.deleteDaysDiscount,

  // Rent Periods
  getRentPeriod: RentPeriodService.getRentPeriod,
  getRentPeriodById: RentPeriodService.getRentPeriodById,
  getRentPeriodsByProxyType: RentPeriodService.getRentPeriodsByProxyType,
  createRentPeriod: RentPeriodService.createRentPeriod,
  saveRentPeriod: RentPeriodService.saveRentPeriod,
  deleteRentPeriod: RentPeriodService.deleteRentPeriod,

  // Mobile Tariffs
  getMobileTariffAll: MobileTariffService.getMobileTariffAll,
  getMobileTariffById: MobileTariffService.getMobileTariffById,
  saveMobileTariff: MobileTariffService.saveMobileTariff,
  addMobileTariff: MobileTariffService.addMobileTariff,
  deleteMobileTariff: MobileTariffService.deleteMobileTariff,
  getSyncronizeMobileOperators: MobileTariffService.getSyncronizeMobileOperators,
  changeIndicesMobileTariff: MobileTariffService.changeIndicesMobileTariff,
  getTagsMobileOperatorsFromCRM: MobileTariffService.getTagsMobileOperatorsFromCRM,

  // Metadata
  getMetaDate: MetadataService.getMetaDate,
  getMetaDateByLocale: MetadataService.getMetaDateByLocale,
  getMetaDateById: MetadataService.getMetaDateById,
  createMetaDate: MetadataService.createMetaDate,
  saveMetaDate: MetadataService.saveMetaDate,
  deleteMetaDate: MetadataService.deleteMetaDate,
  getTips: MetadataService.getTips,
  changeTipsOrder: MetadataService.changeTipsOrder,
  getTipsById: MetadataService.getTipsById,
  createTips: MetadataService.createTips,
  saveTips: MetadataService.saveTips,
  deleteTips: MetadataService.deleteTips,
  getAdvantages: MetadataService.getAdvantages,
  getAdvantagesById: MetadataService.getAdvantagesById,
  saveAdvantages: MetadataService.saveAdvantages,
  changeAdvantagesOrder: MetadataService.changeAdvantagesOrder,
  createAdvantages: MetadataService.createAdvantages,
  deleteAdvantages: MetadataService.deleteAdvantages,

  // FAQ
  getFaq: FaqService.getFaq,
  getFaqByLocale: FaqService.getFaqByLocale,
  getFaqById: FaqService.getFaqById,
  createFaq: FaqService.createFaq,
  saveFaq: FaqService.saveFaq,
  deleteFaq: FaqService.deleteFaq,
  changeFaqOrder: FaqService.changeFaqOrder,
  getFaqTopicsV2: FaqService.getFaqTopicsV2,
  getFaqTopicByIdV2: FaqService.getFaqTopicByIdV2,
  createFaqTopicV2: FaqService.createFaqTopicV2,
  updateFaqTopicV2: FaqService.updateFaqTopicV2,
  changeOrderFaqTopicsV2: FaqService.changeOrderFaqTopicsV2,
  deleteFaqTopicV2: FaqService.deleteFaqTopicV2,
  getFaqItemsByLocaleAndTopicIdV2: FaqService.getFaqItemsByLocaleAndTopicIdV2,
  getFaqItemByIdV2: FaqService.getFaqItemByIdV2,
  createFaqItemV2: FaqService.createFaqItemV2,
  updateFaqItemV2: FaqService.updateFaqItemV2,
  changeOrderFaqItemsV2: FaqService.changeOrderFaqItemsV2,
  deleteFaqItemV2: FaqService.deleteFaqItemV2,
  getFaqTopicsV3: FaqService.getFaqTopicsV3,
  getFaqTopicByIdV3: FaqService.getFaqTopicByIdV3,
  createFaqTopicV3: FaqService.createFaqTopicV3,
  updateFaqTopicV3: FaqService.updateFaqTopicV3,
  changeOrderFaqTopicsV3: FaqService.changeOrderFaqTopicsV3,
  deleteFaqTopicV3: FaqService.deleteFaqTopicV3,
  getFaqItemsByLocaleAndTopicIdV3: FaqService.getFaqItemsByLocaleAndTopicIdV3,
  getFaqItemByIdV3: FaqService.getFaqItemByIdV3,
  createFaqItemV3: FaqService.createFaqItemV3,
  updateFaqItemV3: FaqService.updateFaqItemV3,
  changeOrderFaqItemsV3: FaqService.changeOrderFaqItemsV3,
  deleteFaqItemV3: FaqService.deleteFaqItemV3,

  // Email
  getMailsOnProcessInfo: EmailService.getMailsOnProcessInfo,
  getEmailTemplatesByLocale: EmailService.getEmailTemplatesByLocale,
  getEmailTemplateById: EmailService.getEmailTemplateById,
  saveEmailTemplateById: EmailService.saveEmailTemplateById,
  deleteEmailTemplate: EmailService.deleteEmailTemplate,
  getAllDateFormats: EmailService.getAllDateFormats,
  getDateFormatById: EmailService.getDateFormatById,
  saveDateFormatById: EmailService.saveDateFormatById,
  createDateFormat: EmailService.createDateFormat,
  deleteDateFormat: EmailService.deleteDateFormat,
  getAllMailTemplatesV2: EmailService.getAllMailTemplatesV2,
  getMailTemplateByIdV2: EmailService.getMailTemplateByIdV2,
  saveMailTemplateV2: EmailService.saveMailTemplateV2,
  viewMailTemplateV2: EmailService.viewMailTemplateV2,
  sendTestEmailV2: EmailService.sendTestEmailV2,
  getSpamTemplate: EmailService.getSpamTemplate,
  saveSpamTemplate: EmailService.saveSpamTemplate,
  sendSpam: EmailService.sendSpam,
  checkSpam: EmailService.checkSpam,
  getCurentAmountMembers: EmailService.getCurentAmountMembers,
  sendSpamTest: EmailService.sendSpamTest,

  // Orders
  getOrders: OrderService.getOrders,
  getOrderById: OrderService.getOrderById,
  saveOrder: OrderService.saveOrder,
  confirmOrderPaymentById: OrderService.confirmOrderPaymentById,
  getReplenishments: OrderService.getReplenishments,
  confirmedReplenishmentsById: OrderService.confirmedReplenishmentsById,
  getOrdersExtend: OrderService.getOrdersExtend,
  getExtendProxies: OrderService.getExtendProxies,
  getExtendProxyById: OrderService.getExtendProxyById,
  updateIpIds: OrderService.updateIpIds,
  confirmPaymentExtendProxies: OrderService.confirmPaymentExtendProxies,

  // Analytics
  getGa4HistoryOrders: AnalyticsService.getGa4HistoryOrders,
  getGa4HistoryById: AnalyticsService.getGa4HistoryById,

  // Telegram Metrics
  getTelegramMetrics: TelegramMetricsService.getAll,

  // CRM
  getHistoryCrm: CrmService.getHistoryCrm,
  getRequestTypes: CrmService.getRequestTypes,
  getHistoryCrmItemById: CrmService.getHistoryCrmItemById,

  // SEO
  getSeoByLocale: SeoService.getSeoByLocale,
  getSeoById: SeoService.getSeoById,
  saveSeo: SeoService.saveSeo,
  addSeo: SeoService.addSeo,
  deleteSeo: SeoService.deleteSeo,

  // Notifications
  getWebNotifications: NotificationService.getWebNotifications,
  getWebNotificationById: NotificationService.getWebNotificationById,
  saveWebNotification: NotificationService.saveWebNotification,
  viewWebNotification: NotificationService.viewWebNotification,

  // Files
  file: {
    getById: FileService.getById,
    getAll: FileService.getAll,
    create: FileService.create,
    update: FileService.update,
    deleteById: FileService.deleteById,
  },
  getFrontErrorReportPage: FileService.getFrontErrorReportPage,
  getFrontErrorReportEntity: FileService.getFrontErrorReportEntity,

  // Browser Addon
  getUserAgents: BrowserAddonService.getUserAgents,
  getUserAgentById: BrowserAddonService.getUserAgentById,
  createUserAgent: BrowserAddonService.createUserAgent,
  updateUserAgent: BrowserAddonService.updateUserAgent,
  deleteUserAgent: BrowserAddonService.deleteUserAgent,
  changeUserAgentsIndices: BrowserAddonService.changeUserAgentsIndices,
  getUserDevicesByEmail: BrowserAddonService.getUserDevicesByEmail,
  getUserDeviceByID: BrowserAddonService.getUserDeviceByID,

  // Proxy Packages
  getProxyPackages: ProxyPackageService.getProxyPackages,
  getProxyPackageById: ProxyPackageService.getProxyPackageById,
  getProxyPackageByType: ProxyPackageService.getProxyPackageByType,
  updateProxyPackage: ProxyPackageService.updateProxyPackage,

  // Migration
  downloadMigration: MigrationService.downloadMigration,
  uploadMigration: MigrationService.uploadMigration,
  renewDB: MigrationService.renewDB,

  // Settings
  settingsASES: SettingsService.settingsASES,
  settingsSMTP: SettingsService.settingsSMTP,
  getActiveMailService: SettingsService.getActiveMailService,
  setActiveMailService: SettingsService.setActiveMailService,
  settingsASESSave: SettingsService.settingsASESSave,
  settingsSMTPSave: SettingsService.settingsSMTPSave,
  settingsFullInit: SettingsService.settingsFullInit,
  settingsClearCache: SettingsService.settingsClearCache,
  getUserBalanceSetting: SettingsService.getUserBalanceSetting,
  setUserBalanceSetting: SettingsService.setUserBalanceSetting,
  getTelegramSetting: SettingsService.getTelegramSetting,
  setTelegramSetting: SettingsService.setTelegramSetting,
  getWhatsAppSetting: SettingsService.getWhatsAppSetting,
  setWhatsAppSetting: SettingsService.setWhatsAppSetting,
  getPaddleSubscriptionConfig: SettingsService.getPaddleSubscriptionConfig,
  setPaddleSubscriptionConfig: SettingsService.setPaddleSubscriptionConfig,
  getPipeDriveSetting: SettingsService.getPipeDriveSetting,
  setPipeDriveSetting: SettingsService.setPipeDriveSetting,
  getLumeniqSetting: SettingsService.getLumeniqSetting,
  setLumeniqSetting: SettingsService.setLumeniqSetting,
  getValidateEmailSetting: SettingsService.getValidateEmailSetting,
  setValidateEmailSetting: SettingsService.setValidateEmailSetting,
  getTypeProxiesSettings: SettingsService.getTypeProxiesSettings,
  setTypeProxiesSettings: SettingsService.setTypeProxiesSettings,
  getGoalsSettings: SettingsService.getGoalsSettings,
  setGoalsSettings: SettingsService.setGoalsSettings,
  getCaptchaKey: SettingsService.getCaptchaKey,
  getCaptchaSettings: SettingsService.getCaptchaSettings,
  getCfCaptchaSettings: SettingsService.getCfCaptchaSettings,
  saveCfCaptchaSettings: SettingsService.saveCfCaptchaSettings,
  saveCaptchaSettings: SettingsService.saveCaptchaSettings,
  getGa4analiticsSettings: SettingsService.getGa4analiticsSettings,
  saveGa4analiticsSettings: SettingsService.saveGa4analiticsSettings,
  getCRMSettings: SettingsService.getCRMSettings,
  saveCRMSettings: SettingsService.saveCRMSettings,
  getCompanyEmailSettings: SettingsService.getCompanyEmailSettings,
  saveCompanyEmailSettings: SettingsService.saveCompanyEmailSettings,
  getHeaderTagsSettings: SettingsService.getHeaderTagsSettings,
  saveHeaderTagsSettings: SettingsService.saveHeaderTagsSettings,
  getBodyTagsSettings: SettingsService.getBodyTagsSettings,
  saveBodyTagsSettings: SettingsService.saveBodyTagsSettings,
  getNewDesignEnabled: SettingsService.getNewDesignEnabled,
  setNewDesignEnabled: SettingsService.setNewDesignEnabled,
  getDebagger: SettingsService.getDebagger,
  setDebagger: SettingsService.setDebagger,
  getV2AutoextendSystemSettings: SettingsService.getV2AutoextendSystemSettings,
  getHideCountrySettings: SettingsService.getHideCountrySettings,
  setV2AutoextendSystemSettings: SettingsService.setV2AutoextendSystemSettings,
  setHideCountrySettings: SettingsService.setHideCountrySettings,
  getWebNotificationsSettings: SettingsService.getWebNotificationsSettings,
  setWebNotificationsSettings: SettingsService.setWebNotificationsSettings,
  getSocketProcess: SettingsService.getSocketProcess,
  setSocketProcess: SettingsService.setSocketProcess,
};

export default apiService;
